import React, { ReactNode } from 'react';

import { Button, Dialog, Divider, Typography } from '@sravni/react-design-system';
import { ArrowLeft, ArrowRight } from '@sravni/react-icons';

import { Step } from './Step';
import styles from './styles.module.scss';

interface Props {
  step: number;
  onChange: (step: number) => void;
  visible?: boolean;
  onClose?: () => void;
  children?: ReactNode;
}

export const ModalStepper: React.FC<Props> & { Step: typeof Step } = ({
  children,
  step,
  visible,
  onChange,
  onClose,
}) => {
  const childArr = React.Children.toArray(children);

  const currentStep = childArr[step];

  //@ts-ignore
  if (!React.isValidElement(currentStep) && currentStep.type.displayName === 'Step') {
    throw new Error('not valid element');
  }

  //@ts-ignore
  const { title } = currentStep.props;

  return (
    <Dialog visible={visible} className={styles.container} onClose={onClose}>
      <Typography.Text className={styles.title}>{title}</Typography.Text>
      <Divider className={styles.divider} />
      {currentStep}
      <div className={styles.actions}>
        <Button variant="secondary" onClick={() => onChange(step - 1)} disabled={step === 0}>
          <ArrowLeft className={styles.icon} />
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            if (step < childArr.length - 1) {
              onChange(step + 1);
            } else {
              onClose?.();
            }
          }}
        >
          Далее <ArrowRight className={styles.icon} />
        </Button>
      </div>
    </Dialog>
  );
};

ModalStepper.Step = Step;
